import React, { useState, useRef } from 'react';
import moment from 'moment-timezone';
const XLSX = require('xlsx');

const FinancialDRE = ({ data, branches }) => {

    const [dre, setDre] = useState([]);
    const totalsDeductionPerBranch = useRef([]);
    const totalLiquidReceiptPerBranch = useRef([]);
    const totalVariableExpensesPerBranch = useRef([]);
    const totalFixedExpensesPerBranch = useRef([]);
    const totalMargemContribuicaoPorBranch = useRef([]);
    const totalResultadoOperacionalPorBranch = useRef([]);
    const totalNaoOperacionalPerBranch = useRef([]);
    const totalDespesaTotalPorBranch = useRef([]);
    const totalResultadoLiquidoPorBranch = useRef([]);
    const totalPontoEquilibrioPorBranch = useRef([]);
    const totalDespesaPorUnidadePorBranch = useRef([]);

    const totalProjectionValue = useRef(0);
    const totalAveragePerUnit = useRef(0);
    
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    const generateDreTableParts = (part) => {
        switch (part) {
            case 'titulo-tabela':
                return (
                    branches.map((branch, index) => {
                        return (
                            <>
                                <th>{branch.FILIAL}</th>
                                <th>% REC</th>
                                {index == branches.length - 1 && (
                                    <>
                                        <th>&nbsp;</th>
                                        <th>Total</th>
                                        <th>% REC</th>
                                        <th>Projeção 12 meses</th>
                                        <th>% REC</th>
                                        <th>Média por unidade</th>
                                        <th>% REC</th>
                                    </>
                                )}
                            </>
                        )
                    })
                )

            case 'receita-bruta':
                let totalReceitaBruta = 0;
                return (
                    branches.map((branch, index) => {
                        const findData = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID);
                        //console.log('receita-bruta: ', findData);
                        const totalReceitaBrutaCurrentBranch = findData?.total_approved ?? 0;
                        totalReceitaBruta += Number(totalReceitaBrutaCurrentBranch);

                        totalProjectionValue.current = totalReceitaBruta * 12;
                        totalAveragePerUnit.current = totalReceitaBruta / branches.length;
                        return (
                            <>
                                <th className="text-end">{formatCurrency(totalReceitaBrutaCurrentBranch)}</th>
                                <th className="text-center">100%</th>
                                {index == branches.length - 1 && (
                                    <>
                                        <th>&nbsp;</th>
                                        <th className="text-end">{formatCurrency(totalReceitaBruta)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaBruta * 12)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaBruta / branches.length)}</th>
                                        <th className="text-center">100%</th>
                                    </>
                                )}
                            </>
                        )
                    })
                )

            case 'receita-bruta:receita-cliente':
                let totalReceitaCliente = 0;
                return (
                    branches.map((branch, index) => {
                        const findData = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID);
                        //console.log('receita-bruta:receita-cliente:', findData);
                        const totalReceitaClienteCurrentBranch = findData?.total_approved ?? 0;
                        totalReceitaCliente += Number(totalReceitaClienteCurrentBranch);
                        return (
                            <>
                                <th className="text-end">{formatCurrency(totalReceitaClienteCurrentBranch)}</th>
                                <th className="text-center">100%</th>
                                {index == branches.length - 1 && (
                                    <>
                                        <th>&nbsp;</th>
                                        <th className="text-end">{formatCurrency(totalReceitaCliente)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaCliente * 12)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaCliente / branches.length)}</th>
                                        <th className="text-center">100%</th>
                                    </>
                                )}
                            </>
                        )
                    })
                )

            case 'receita-bruta:receita-juros-aplicacao-bancaria':
                let totalReceitaJurosAplicacaoBancaria = 0;
                return (
                    branches.map((branch, index) => {
                        return (
                            <>
                                <th className="text-end">R$ 0,00</th>
                                <th className="text-center">0%</th>
                                {index == branches.length - 1 && (
                                    <>
                                        <th>&nbsp;</th>
                                        <th className="text-end">{formatCurrency(totalReceitaJurosAplicacaoBancaria)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaJurosAplicacaoBancaria * 12)}</th>
                                        <th className="text-center">100%</th>
                                        <th className="text-end">{formatCurrency(totalReceitaJurosAplicacaoBancaria / branches.length)}</th>
                                        <th className="text-center">100%</th>
                                    </>
                                )}
                            </>
                        )
                    })
                )

            case 'receita-bruta:totals-percent':
                let totalPercent = 0;
                return (
                    branches.map((branch, index) => {
                        // quantos % o faturamento equivale do total dentro de data.revenue.total
                        const totalReceitaBruta = data.revenue.total;
                        const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                        const percent = totalReceitaBruta == 0 ? 0 :(totalReceitaBrutaBranch / totalReceitaBruta) * 100;
                        totalPercent += percent;
                        return (
                            <>
                                <th className="text-center">{percent.toFixed(2)}%</th>
                                <th>&nbsp;</th>
                                {index == branches.length - 1 && (
                                    <>
                                        <th>&nbsp;</th>
                                        <th className="text-center">{totalPercent.toFixed(2)}%</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                        <th>&nbsp;</th>
                                    </>
                                )}
                            </>
                        )
                    })
                )

            case 'deducao-de-receita':
                let subcategorias = data.expenses_hierarchy[1].SUBCATEGORIAS;
                //let totalsDeductionPerBranch = [];
                let totalDecutionsValue = 0;
                let totalSumPercent = 0;
                let mountSubcategoriesRows = subcategorias.map((subcategoria) => {
                    let sumTotalSubcategory = 0;
                    return (
                        <tr className="sublevel">
                            <td>&nbsp;</td>
                            <td>{subcategoria.NOME}</td>
                            {branches.map((branch, index) => {
                                // find sum the VALOR_TOTAL inside subcategoria.ITENS that have FILIAL equals branch.FILIAL
                                const totalSubcategoriaBranch = subcategoria.ITENS.filter(item => item.FILIAL == branch.FILIAL).reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0);
                                //console.log('totalSubcategoriaBranch: ', totalSubcategoriaBranch);
                                // now calculate how much percent this totalSubcategoriaBranch is of the totalReceitaBrutaBranch
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const percent = totalReceitaBrutaBranch == 0 ? 0 :(totalSubcategoriaBranch / totalReceitaBrutaBranch) * 100;
                                const totalReceitaBruta = data.revenue.total;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBruta == 0 ? 0 :(sumTotalSubcategory / totalReceitaBruta) * 100;

                                if (!totalsDeductionPerBranch.current[branch.ID]) {
                                    totalsDeductionPerBranch.current[branch.ID] = {
                                        total: totalSubcategoriaBranch
                                    };
                                } else {
                                    totalsDeductionPerBranch.current[branch.ID].total += totalSubcategoriaBranch;
                                }
                                totalDecutionsValue += totalSubcategoriaBranch;
                                sumTotalSubcategory += totalSubcategoriaBranch;
                                //console.log('totalSubcategoriaBranch', totalSubcategoriaBranch);

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((sumTotalSubcategory * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((sumTotalSubcategory / branches.length) / totalAveragePerUnit.current) * 100;

                                //console.log('totalProjectionValue.current', totalProjectionValue.current);
                                //console.log('totalAveragePerUnit.current', totalAveragePerUnit.current);
                                
                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(totalSubcategoriaBranch)}</td>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(sumTotalSubcategory)}</td>
                                                <td className="text-center">{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(sumTotalSubcategory * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(sumTotalSubcategory / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                    )
                })

            return (
                <>
                    <tr className="yellow-row">
                            <td>2</td>
                            <td>DEDUÇÃO DE RECEITA</td>
                            {branches.map((branch, index) => {
                                let totalDeducted = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                let percent = totalReceitaBrutaBranch == 0 ? 0 :(totalDeducted / totalReceitaBrutaBranch) * 100;

                                const totalReceitaBruta = data.revenue.total;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBruta == 0 ? 0 :(totalDecutionsValue / totalReceitaBruta) * 100;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalDecutionsValue * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = (totalAveragePerUnit.current == 0 ? 0 :((totalDecutionsValue / branches.length) / totalAveragePerUnit.current) * 100);

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(totalDeducted)}</td>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalDecutionsValue)}</td>
                                                <td className="text-center">{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalDecutionsValue * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalDecutionsValue / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {mountSubcategoriesRows}
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                let totalDeducted = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                let percent = totalDecutionsValue == 0 ? 0 :(totalDeducted / totalDecutionsValue) * 100;

                                totalSumPercent += percent;
                                return (
                                    <>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        <td >&nbsp;</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalSumPercent.toFixed(2)}%</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'receita-liquida':
                let totalSumReceitaLiquida = 0;
                let totalSumPercentReceitaLiquida = 0;
                return (
                    <>
                        <tr className="receita-liquida-row">
                            <td>3</td>
                            <td>RECEITA LÍQUIDA (1-2)</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBruta = data.revenue.total;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDeducted = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalReceitaLiquida = totalReceitaBrutaBranch - totalDeducted;
                                totalLiquidReceiptPerBranch.current[branch.ID] = totalReceitaLiquida;
                                const percent = totalReceitaBrutaBranch == 0 ? 0 :(totalReceitaLiquida / totalReceitaBrutaBranch) * 100;

                                totalSumReceitaLiquida += totalReceitaLiquida;
                                const totalPercentBasedOnTotalReceitaBruta = totalReceitaBruta == 0 ? 0 :(totalSumReceitaLiquida / totalReceitaBruta) * 100;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalSumReceitaLiquida * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalSumReceitaLiquida / branches.length) / totalAveragePerUnit.current) * 100;
                               
                                return (
                                    <>
                                        <td className="text-center">{formatCurrency(totalReceitaLiquida)}</td>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalSumReceitaLiquida)}</td>
                                                <td className="text-center">{totalPercentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalSumReceitaLiquida * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalSumReceitaLiquida / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBruta = data.revenue.total;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDeducted = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalReceitaLiquida = totalReceitaBrutaBranch - totalDeducted;
                                const percent = totalReceitaBruta == 0 ? 0 :(totalReceitaLiquida / totalSumReceitaLiquida) * 100;
                                totalSumPercentReceitaLiquida += percent;
                                return (
                                    <>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        <td>&nbsp;</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalSumPercentReceitaLiquida.toFixed(2)}%</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'margem-contribuicao':
                let totalMargemContribuicao = 0;
                let totalSumPercentMargemContribuicao = 0;
                
                return (
                    <>
                        <tr className="margem-contribuicao-row">
                            <td>5</td>
                            <td>MARGEM DE CONTRIBUIÇÃO (1-2-4)</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBruta = data.revenue.total;
                                const totalReceitaLiquidaBranch = totalLiquidReceiptPerBranch.current?.[branch.ID] ?? 0;
                                //console.log('totalLiquidReceiptPerBranch.current?.[branch.ID]', totalLiquidReceiptPerBranch.current?.[branch.ID]);
                                const totalVariableExpensesBranch = totalVariableExpensesPerBranch.current?.[branch.ID].total ?? 0;
                                //console.log('totalVariableExpensesPerBranch.current?.[branch.ID]', totalVariableExpensesPerBranch.current?.[branch.ID]);
                                const margemContribuicao = totalReceitaLiquidaBranch - totalVariableExpensesBranch;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const percent = totalReceitaBrutaBranch == 0 ? 0 :(margemContribuicao / totalReceitaBrutaBranch) * 100;
                                totalMargemContribuicaoPorBranch.current[branch.ID] = margemContribuicao;
                                totalMargemContribuicao += margemContribuicao;

                                const percentMargemContribuicaoUponReceitaBruta = totalReceitaBruta == 0 ? 0 :(totalMargemContribuicao / totalReceitaBruta) * 100;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalMargemContribuicao * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalMargemContribuicao / branches.length) / totalAveragePerUnit.current) * 100;

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(margemContribuicao)}</td>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalMargemContribuicao.toFixed(2)}%</td>
                                                <td className="text-center">{percentMargemContribuicaoUponReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalMargemContribuicao * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalMargemContribuicao / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const margemContribuicao = totalMargemContribuicaoPorBranch.current?.[branch.ID] ?? 0;
                                const percent = totalMargemContribuicao == 0 ? 0 :(margemContribuicao / totalMargemContribuicao) * 100;
                                totalSumPercentMargemContribuicao += percent;
                                return (
                                    <>
                                        <td className="text-center">{percent.toFixed(2)}%</td>
                                        <td>&nbsp;</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalSumPercentMargemContribuicao.toFixed(2)}%</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'resultado-operacional':
                let totalResultadoOperacional = 0;
                let totalSumPercentResultadoOperacional = 0;
                return (
                    <>
                        <tr className="resultado-operacional-row">
                            <td>7</td>
                            <td>RESULTADO OPERACIONAL (1-2-4-6)</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBruta = data.revenue.total;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDeducoesBranch = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalVariableExpensesBranch = totalVariableExpensesPerBranch.current?.[branch.ID].total ?? 0;
                                const totalFixedExpensesBranch = totalFixedExpensesPerBranch.current?.[branch.ID].total ?? 0;
                                const resultadoOperacional = totalReceitaBrutaBranch - totalDeducoesBranch - totalVariableExpensesBranch - totalFixedExpensesBranch;

                                const percentBasedOnTotalReceitaBruta = totalReceitaBrutaBranch == 0 ? 0 :(resultadoOperacional / totalReceitaBrutaBranch) * 100;
                                totalResultadoOperacional += resultadoOperacional;
                                totalResultadoOperacionalPorBranch.current[branch.ID] = resultadoOperacional;

                                const percentTotalSumBasedOnTotalReceitaBruta = totalReceitaBruta == 0 ? 0 :(totalResultadoOperacional / totalReceitaBruta) * 100;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalResultadoOperacional * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalResultadoOperacional / branches.length) / totalAveragePerUnit.current) * 100;

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(resultadoOperacional)}</td>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(resultadoOperacional)} de ${formatCurrency(totalReceitaBrutaBranch)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalResultadoOperacional)}</td>
                                                <td className="text-center">{percentTotalSumBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalResultadoOperacional * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalResultadoOperacional / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const totalResultadoOperacionalBranch = totalResultadoOperacionalPorBranch.current?.[branch.ID] ?? 0;
                                const percentBasedOnResultadoOperacional = totalResultadoOperacional == 0 ? 0 :(totalResultadoOperacionalBranch / totalResultadoOperacional) * 100;
                                totalSumPercentResultadoOperacional += percentBasedOnResultadoOperacional;
                                return (
                                    <>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalResultadoOperacionalBranch)} de ${formatCurrency(totalResultadoOperacional)}`}>{percentBasedOnResultadoOperacional.toFixed(2)}%</td>
                                        <td>&nbsp;</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalSumPercentResultadoOperacional.toFixed(2)}%</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'despesa-total':
                let totalDespesaTotal = 0;
                return (
                    <>
                        <tr className="despesa-total-row">
                            <td>9</td>
                            <td>DESPESA TOTAL (2+4+6+8)</td>
                            {branches.map((branch, index) => {
                                const totalDeducoesBranch = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalVariableExpensesBranch = totalVariableExpensesPerBranch.current?.[branch.ID].total ?? 0;
                                const totalFixedExpensesBranch = totalFixedExpensesPerBranch.current?.[branch.ID].total ?? 0;
                                const totalNaoOperacionalBranch = totalNaoOperacionalPerBranch.current?.[branch.ID].total ?? 0;
                                const totalDespesaTotalCurrentBranch = totalDeducoesBranch + totalVariableExpensesBranch + totalFixedExpensesBranch + totalNaoOperacionalBranch;
                                //console.log('========= FILIAL '+branch.ID+' =========');
                                //console.log('BEFORE totalDespesaTotal', totalDespesaTotal);
                                //console.log('totalDespesaTotalCurrentBranch', totalDespesaTotalCurrentBranch);
                            
                                totalDespesaTotalPorBranch.current[branch.ID] = totalDespesaTotalCurrentBranch;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBrutaBranch == 0 ? 0 :(totalDespesaTotalCurrentBranch / totalReceitaBrutaBranch) * 100;
                                totalDespesaTotal = Number(totalDespesaTotal) + Number(totalDespesaTotalCurrentBranch);
                                //console.log('totalDespesaTotal', totalDespesaTotal);

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalDespesaTotal * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalDespesaTotal / branches.length) / totalAveragePerUnit.current) * 100;

                                //console.log('totalDespesaTotalPorBranch.current', totalDespesaTotalPorBranch.current);
                                const total = totalDespesaTotalPorBranch.current.reduce((sum, value) => sum + value, 0);
                                //console.log('total total', total);

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(totalDespesaTotalCurrentBranch)}</td>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalDespesaTotalCurrentBranch)} de ${formatCurrency(totalReceitaBrutaBranch)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalDespesaTotal)}</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalDespesaTotal * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalDespesaTotal / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const totalDespesaTotalBranch = totalDespesaTotalPorBranch.current?.[branch.ID] ?? 0;
                                const percentBasedOn = totalDespesaTotal == 0 ? 0 :(totalDespesaTotalBranch / totalDespesaTotal) * 100;
                                return (
                                    <>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalDespesaTotalBranch)} de ${formatCurrency(totalDespesaTotal)}`}>{percentBasedOn.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'resultado-liquido':
                let totalResultadoLiquido = 0;
                return (
                    <>
                        <tr className="resultado-liquido-row">
                            <td>10</td>
                            <td>RESULTADO LÍQUIDO (1-9)</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDespesaTotalBranch = totalDespesaTotalPorBranch.current?.[branch.ID] ?? 0;
                                const resultadoLiquido = totalReceitaBrutaBranch - totalDespesaTotalBranch;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBrutaBranch == 0 ? 0 :(resultadoLiquido / totalReceitaBrutaBranch) * 100;
                                totalResultadoLiquido += resultadoLiquido;
                                totalResultadoLiquidoPorBranch.current[branch.ID] = resultadoLiquido;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((resultadoLiquido * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((resultadoLiquido / branches.length) / totalAveragePerUnit.current) * 100;

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(resultadoLiquido)}</td>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(resultadoLiquido)} de ${formatCurrency(totalReceitaBrutaBranch)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalResultadoLiquido)}</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalResultadoLiquido * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalResultadoLiquido / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const totalResultadoLiquidoBranch = totalResultadoLiquidoPorBranch.current?.[branch.ID] ?? 0;
                                const percentBasedOn = totalResultadoLiquido == 0 ? 0 :(totalResultadoLiquidoBranch / totalResultadoLiquido) * 100;
                                return (
                                    <>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalResultadoLiquidoBranch)} de ${formatCurrency(totalResultadoLiquido)}`}>{percentBasedOn.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'ponto-equilibrio':
                let totalPontoEquilibrio = 0;
                return (
                    <>
                        <tr className="ponto-equilibrio-row">
                            <td>11</td>
                            <td>PONTO DE EQUILÍBRIO</td>
                            {branches.map((branch, index) => {
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDespesaNaoOperacionalBranch = totalNaoOperacionalPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalDespesaFixaBranch = totalFixedExpensesPerBranch.current?.[branch.ID]?.total ?? 0;
                                const margemContribuiacaoBranch = totalMargemContribuicaoPorBranch.current?.[branch.ID] ?? 0;
                                const margemDeContrbuiacaoPercentual = totalReceitaBrutaBranch == 0 ? 0 :(margemContribuiacaoBranch / totalReceitaBrutaBranch) * 100;
                                const pontoEquilibrio = margemDeContrbuiacaoPercentual == 0 ? 0 :((totalDespesaNaoOperacionalBranch+totalDespesaFixaBranch) / margemDeContrbuiacaoPercentual) * 100;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBrutaBranch == 0 ? 0 :(pontoEquilibrio / totalReceitaBrutaBranch) * 100;

                                totalPontoEquilibrio += pontoEquilibrio;
                                totalPontoEquilibrioPorBranch.current[branch.ID] = pontoEquilibrio;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((pontoEquilibrio * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((pontoEquilibrio / branches.length) / totalAveragePerUnit.current) * 100;

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(pontoEquilibrio)}</td>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(pontoEquilibrio)} de ${formatCurrency(totalReceitaBrutaBranch)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalPontoEquilibrio)}</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalPontoEquilibrio * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalPontoEquilibrio / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                        {generateDreTableParts('jump-line')}
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'despesa-por-unidade':
                let totalDespesaPorUnidade = 0;
                return (
                    <>
                        <tr className="despesa-por-unidade-row">
                            <td></td>
                            <td>DESPESA POR UNIDADE (6+8)</td>
                            {branches.map((branch, index) => {
                                const totalDespesaFixaBranch = totalFixedExpensesPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalDespesaNaoOperacionalBranch = totalNaoOperacionalPerBranch.current?.[branch.ID]?.total ?? 0;
                                let totalDespesaPorUnidadeCurrentBranch = totalDespesaFixaBranch + totalDespesaNaoOperacionalBranch;
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const percentBasedOnTotalReceitaBruta = totalReceitaBrutaBranch == 0 ? 0 :(totalDespesaPorUnidadeCurrentBranch / totalReceitaBrutaBranch) * 100;
                                totalDespesaPorUnidade += totalDespesaPorUnidadeCurrentBranch;
                                totalDespesaPorUnidadePorBranch.current[branch.ID] = totalDespesaPorUnidadeCurrentBranch;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalDespesaPorUnidade * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalDespesaPorUnidade / branches.length) / totalAveragePerUnit.current) * 100;

                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(totalDespesaPorUnidadeCurrentBranch)}</td>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalDespesaPorUnidadeCurrentBranch)} de ${formatCurrency(totalReceitaBrutaBranch)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalDespesaPorUnidade)}</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalDespesaPorUnidade * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalDespesaPorUnidade / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                const totalDespesaPorUnidadeBranch = totalDespesaPorUnidadePorBranch.current?.[branch.ID] ?? 0;
                                const percentBasedOn = totalDespesaPorUnidade == 0 ? 0 :(totalDespesaPorUnidadeBranch / totalDespesaPorUnidade) * 100;
                                return (
                                    <>
                                        <td className="text-center" data-tippy-content={`${formatCurrency(totalDespesaPorUnidadeBranch)} de ${formatCurrency(totalDespesaPorUnidade)}`}>{percentBasedOn.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                    </>
                )

            case 'jump-line':
                return (
                    <tr>
                            <td colSpan={branches.length + 2}>
                            &nbsp;
                        </td>
                    </tr>
                )
                
        }
    }

    const generateDreTableFullcategory = (category) => {

        let HIERARCHY_LEVEL = 2;
        switch (category) {
            case 'despesa-variavel':
                HIERARCHY_LEVEL = 2;
                break;
            case 'despesa-fixa':
                HIERARCHY_LEVEL = 3;
                break;
            case 'despesa-nao-operacional':
                HIERARCHY_LEVEL = 4;
                break;
        }
        //switch (category) {
        //    case 'despesa-variavel':
                const receitaBruta = data.revenue.total;
                let subcategorias = data.expenses_hierarchy[HIERARCHY_LEVEL].SUBCATEGORIAS;
                let totalSubcategoriaPorBranch = [];
                let totalPorSubcategoria = [];
                let totalSumFullCategory = 0;
                // we need to sum up all total of subcategories and subcategories

                //const totalExpenses = subcategorias.reduce((acc, subcategoria) => acc + subcategoria.SUBCATEGORIAS.reduce((acc, subcategoriaFilha) => acc + subcategoriaFilha.ITENS.reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0), 0), 0);
                //console.log('totalExpenses', totalExpenses);

                let mountSubcategoriesRows = subcategorias.map((subcategoria) => {
                    totalSubcategoriaPorBranch = [];
                    totalPorSubcategoria[subcategoria.ID] = subcategoria.SUBCATEGORIAS.reduce((acc, subcategoriaFilha) => acc + subcategoriaFilha.ITENS.reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0), 0);
                    let totalSumSubcategory = 0;
                    let totalSumPercentFullCategory = 0;
                    return (
                        <>
                            <tr className={`${category}-row`}>
                                <td>{subcategoria.NIVEL}</td>
                                <td>{subcategoria.NOME}</td>
                                {branches.map((branch, index) => {
                                    // sum up the total of the subcategoria.ITENS that have FILIAL equals branch.FILIAL
                                    let totalSubcategoriaBranch = subcategoria.SUBCATEGORIAS.reduce((acc, subcategoriaFilha) => acc + subcategoriaFilha.ITENS.filter(item => item.FILIAL == branch.FILIAL).reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0), 0);

                                    totalSubcategoriaBranch = subcategoria.SUBCATEGORIAS.reduce((acc, subcategoriaFilha) => {
                                        const calculateTotal = (subcat) => {
                                            let total = (subcat.ITENS || [])
                                                .filter(item => item.FILIAL == branch.FILIAL)
                                                .reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0);
                                            
                                            if (subcat.SUBCATEGORIAS) {
                                                total += subcat.SUBCATEGORIAS.reduce((acc, nested) => acc + calculateTotal(nested), 0);
                                            }
                                            
                                            return total;
                                        };
                                        
                                        return acc + calculateTotal(subcategoriaFilha);
                                    }, 0);
                                    
                                    const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                    let percent = totalReceitaBrutaBranch == 0 ? 0 :(totalSubcategoriaBranch / totalReceitaBrutaBranch) * 100;

                                    if (subcategoria.NOME == '4.3 IMPOSTO') {
                                        // get 10% of totalReceitaBrutaBranch
                                        percent = 10;
                                        totalSubcategoriaBranch = totalReceitaBrutaBranch * (percent / 100);
                                        totalPorSubcategoria[subcategoria.ID] = totalReceitaBrutaBranch * (percent / 100);

                                        if (category == 'despesa-variavel') {
                                            if (!totalVariableExpensesPerBranch.current[branch.ID]) {
                                                totalVariableExpensesPerBranch.current[branch.ID] = {
                                                    total: totalReceitaBrutaBranch * (percent / 100)
                                                };
                                                totalSubcategoriaPorBranch[branch.ID] = totalReceitaBrutaBranch * (percent / 100);
                                            } else {
                                                totalVariableExpensesPerBranch.current[branch.ID].total += totalReceitaBrutaBranch * (percent / 100);
                                            }
                                        }
                                    }
                                    totalSumSubcategory += totalSubcategoriaBranch;

                                    const percentBasedOnTotalReceitaBruta = receitaBruta == 0 ? 0 :(totalSumSubcategory / receitaBruta) * 100;

                                    const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalSumSubcategory * 12) / totalProjectionValue.current) * 100;
                                    const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalSumSubcategory / branches.length) / totalAveragePerUnit.current) * 100;

                                    return (
                                        <>
                                            <td className="text-end">{formatCurrency(totalSubcategoriaBranch)}</td>
                                            <td className="text-center">{percent.toFixed(2)}%</td>
                                            {index == branches.length - 1 && (
                                                <>
                                                    <td>&nbsp;</td>
                                                    <td className="text-end">{formatCurrency(totalSumSubcategory)}</td>
                                                    <td className="text-center" data-tippy-content={`${formatCurrency(totalSumSubcategory)} de ${formatCurrency(receitaBruta)}`}>{percentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                    <td className="text-end">{formatCurrency(totalSumSubcategory * 12)}</td>
                                                    <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                    <td className="text-end">{formatCurrency(totalSumSubcategory / branches.length)}</td>
                                                    <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                                </>
                                            )}
                                        </>
                                    )
                                })}
                            </tr>
                            {subcategoria.SUBCATEGORIAS.map((subcategoriaFilha) => {
                                let totalSumPerSubcategory = 0;
                                return (
                                    <>
                                    <tr className="sublevel">
                                        <td>&nbsp;</td>
                                        <td>{subcategoriaFilha.NOME}</td>
                                        {branches.map((branch, index) => {
                                            // it its to sum up the total of the subcategoriaFilha.ITENS that have FILIAL_ID equals branch.ID
                                            const totalSubcategoriaFilhaBranch = ((subcat, filial) => {
                                                const calcTotal = (s) => ((s.ITENS || []).filter(item => item.FILIAL == filial).reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0)) + ((s.SUBCATEGORIAS || []).reduce((acc, nested) => acc + calcTotal(nested), 0));
                                                return calcTotal(subcat);
                                            })(subcategoriaFilha, branch.FILIAL);

                                            const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                            const percent = totalReceitaBrutaBranch == 0 ? 0 :(totalSubcategoriaFilhaBranch / totalReceitaBrutaBranch) * 100;

                                            if (category == 'despesa-variavel') {
                                                if (!totalVariableExpensesPerBranch.current[branch.ID]) {
                                                    totalVariableExpensesPerBranch.current[branch.ID] = {
                                                        total: totalSubcategoriaFilhaBranch
                                                    };
                                                    totalSubcategoriaPorBranch[branch.ID] = totalSubcategoriaFilhaBranch;
                                                } else {
                                                    totalVariableExpensesPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                }
                                            } else if (category == 'despesa-fixa') {
                                                if (!totalFixedExpensesPerBranch.current[branch.ID]) {
                                                    totalFixedExpensesPerBranch.current[branch.ID] = {
                                                        total: totalSubcategoriaFilhaBranch
                                                    };
                                                } else {
                                                    totalFixedExpensesPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                }
                                            } else if (category == 'despesa-nao-operacional') {
                                                if (!totalNaoOperacionalPerBranch.current[branch.ID]) {
                                                    totalNaoOperacionalPerBranch.current[branch.ID] = {
                                                        total: totalSubcategoriaFilhaBranch
                                                    };
                                                } else {
                                                    totalNaoOperacionalPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                }
                                            }
                                            totalSubcategoriaPorBranch[branch.ID] += totalSubcategoriaFilhaBranch;
                                            totalSumPerSubcategory += totalSubcategoriaFilhaBranch;

                                            const percentBasedOnTotalSumSubcategory = totalSumPerSubcategory == 0 ? 0 :(totalSumPerSubcategory / receitaBruta) * 100;

                                            const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalSumPerSubcategory * 12) / totalProjectionValue.current) * 100;
                                            const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalSumPerSubcategory / branches.length) / totalAveragePerUnit.current) * 100;

                                            return (
                                                <>
                                                    <td className="text-end">{formatCurrency(totalSubcategoriaFilhaBranch)}</td>
                                                    <td className="text-center">{percent.toFixed(2)}%</td>
                                                    {index == branches.length - 1 && (
                                                        <>
                                                            <td>&nbsp;</td>
                                                            <td className="text-end">{formatCurrency(totalSumPerSubcategory)}</td>
                                                            <td className="text-center" data-tippy-content={`${totalSumPerSubcategory} de ${receitaBruta}`}>{percentBasedOnTotalSumSubcategory.toFixed(2)}%</td>
                                                            <td className="text-end">{formatCurrency(totalSumPerSubcategory * 12)}</td>
                                                            <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                            <td className="text-end">{formatCurrency(totalSumPerSubcategory / branches.length)}</td>
                                                            <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                                        </>
                                                    )}
                                                </>
                                            )
                                        })}
                                    </tr>
                                    {subcategoriaFilha.SUBCATEGORIAS.map((subcategoriaFilhaNivel2) => {
                                        /*let totalSumPerSubCategory2 = 0;
                                        return (
                                            <tr className="sublevel">
                                                <td>&nbsp;</td>
                                                <td>&nbsp;&nbsp;{subcategoriaFilhaNivel2.NOME}</td>
                                                {branches.map((branch, index) => {
                                                    // it its to sum up the total of the subcategoriaFilha.ITENS that have FILIAL_ID equals branch.ID
                                                    const totalSubcategoriaFilhaBranch = subcategoriaFilhaNivel2.ITENS.filter(item => item.FILIAL == branch.FILIAL).reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0);
                                                    const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                                    const percent = totalReceitaBrutaBranch == 0 ? 0 :(totalSubcategoriaFilhaBranch / totalReceitaBrutaBranch) * 100;

                                                    if (category == 'despesa-variavel') {
                                                        if (!totalVariableExpensesPerBranch.current[branch.ID]) {
                                                            totalVariableExpensesPerBranch.current[branch.ID] = {
                                                                total: totalSubcategoriaFilhaBranch
                                                            };
                                                            totalSubcategoriaPorBranch[branch.ID] = totalSubcategoriaFilhaBranch;
                                                        } else {
                                                            //totalVariableExpensesPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                        }
                                                    } else if (category == 'despesa-fixa') {
                                                        if (!totalFixedExpensesPerBranch.current[branch.ID]) {
                                                            totalFixedExpensesPerBranch.current[branch.ID] = {
                                                                total: totalSubcategoriaFilhaBranch
                                                            };
                                                        } else {
                                                            //totalFixedExpensesPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                        }
                                                    } else if (category == 'despesa-nao-operacional') {
                                                        if (!totalNaoOperacionalPerBranch.current[branch.ID]) {
                                                            totalNaoOperacionalPerBranch.current[branch.ID] = {
                                                                total: totalSubcategoriaFilhaBranch
                                                            };
                                                        } else {
                                                            //totalNaoOperacionalPerBranch.current[branch.ID].total += totalSubcategoriaFilhaBranch;
                                                        }
                                                    }
                                                    //totalSubcategoriaPorBranch[branch.ID] += totalSubcategoriaFilhaBranch;
                                                    totalSumPerSubCategory2 += totalSubcategoriaFilhaBranch;

                                                    const percentBasedOnTotalSumSubcategory = totalSumPerSubCategory2 == 0 ? 0 :(totalSumPerSubCategory2 / receitaBruta) * 100;

                                                    const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalSumPerSubCategory2 * 12) / totalProjectionValue.current) * 100;
                                                    const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalSumPerSubCategory2 / branches.length) / totalAveragePerUnit.current) * 100;

                                                    return (
                                                        <>
                                                            <td className="text-end">R$ {totalSubcategoriaFilhaBranch.toFixed(2) ?? 0}</td>
                                                            <td className="text-center">{percent.toFixed(2)}%</td>
                                                            {index == branches.length - 1 && (
                                                                <>
                                                                    <td>&nbsp;</td>
                                                                    <td className="text-end">R$ {totalSumPerSubCategory2.toFixed(2) ?? 0}</td>
                                                                    <td className="text-center" data-tippy-content={`${totalSumPerSubCategory2} de ${receitaBruta}`}>{percentBasedOnTotalSumSubcategory.toFixed(2)}%</td>
                                                                    <td className="text-end">R$ {(totalSumPerSubCategory2 * 12).toFixed(2)}</td>
                                                                    <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                                    <td className="text-end">R$ {(totalSumPerSubCategory2 / branches.length).toFixed(2)}</td>
                                                                    <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                                                </>
                                                            )}
                                                        </>
                                                    )
                                                })}
                                            </tr>
                                        )*/
                                    })}
                                    </>
                                )
                            })}
                            <tr className="total-row">
                                <td>&nbsp;</td>
                                <td className="text-center">% TOTAL</td>
                                {branches.map((branch, index) => {
                                    let currentBranchVariableExpenses = subcategoria.SUBCATEGORIAS.reduce((acc, subcategoriaFilha) => acc + subcategoriaFilha.ITENS.filter(item => item.FILIAL == branch.FILIAL).reduce((acc, item) => acc + Math.abs(Number(item.VALOR)), 0), 0);

                                    if (subcategoria.NOME == '4.3 IMPOSTO') {
                                        // get 10% of totalExpenses
                                        const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                        const imposto = totalReceitaBrutaBranch * 0.1;
                                        currentBranchVariableExpenses += imposto;
                                    }

                                    const percent = totalPorSubcategoria[subcategoria.ID] == 0 ? 0 :(currentBranchVariableExpenses / totalPorSubcategoria[subcategoria.ID]) * 100;
                                    totalSumPercentFullCategory += percent;

                                    return (
                                        <>
                                            <td className="text-center" data-tippy-content={`${currentBranchVariableExpenses} de ${totalPorSubcategoria[subcategoria.ID]}`}>{percent.toFixed(2)}%</td>
                                            <td>&nbsp;</td>
                                            {index == branches.length - 1 && (
                                                <>
                                                    <td>&nbsp;</td>
                                                    <td className="text-end">{totalSumPercentFullCategory.toFixed(2)}%</td>
                                                    <td className="text-center">&nbsp;</td>
                                                    <td className="text-center">&nbsp;</td>
                                                    <td className="text-center">&nbsp;</td>
                                                    <td className="text-center">&nbsp;</td>
                                                    <td className="text-center">&nbsp;</td>
                                                </>
                                            )}
                                        </>
                                    )
                                })}
                            </tr>
                            {generateDreTableParts('jump-line')}
                        </>
                    )
                })


                let totalFullCategorySumPercent = 0;

                return (
                    <>
                        <tr className={`${category}-row`}>
                            <td>{data.expenses_hierarchy[HIERARCHY_LEVEL].NIVEL}</td>
                            <td>{data.expenses_hierarchy[HIERARCHY_LEVEL].NOME}</td>
                            {branches.map((branch, index) => {
                                let totalVariableExpenses = 0;

                                if (category == 'despesa-variavel') {
                                    totalVariableExpenses = totalVariableExpensesPerBranch.current?.[branch.ID]?.total ?? 0;
                                } else if (category == 'despesa-fixa') {
                                    totalVariableExpenses = totalFixedExpensesPerBranch.current?.[branch.ID]?.total ?? 0;
                                } else if (category == 'despesa-nao-operacional') {
                                    totalVariableExpenses = totalNaoOperacionalPerBranch.current?.[branch.ID]?.total ?? 0;
                                }

                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                let percent = totalReceitaBrutaBranch == 0 ? 0 :(totalVariableExpenses / totalReceitaBrutaBranch) * 100;

                                if (category == 'despesa-variavel') {
                                    let impostos = totalReceitaBrutaBranch * 0.1;
                                    //totalVariableExpenses += impostos;
                                    //percent = totalReceitaBrutaBranch == 0 ? 0 :(totalVariableExpenses / totalReceitaBrutaBranch) * 100;
                                }
                                totalSumFullCategory += totalVariableExpenses;
                                //console.log('category', category, 'receitaBruta', receitaBruta, 'totalVariableExpenses', totalVariableExpenses);
                                const totalPercentBasedOnTotalReceitaBruta = receitaBruta == 0 ? 0 :(totalSumFullCategory / receitaBruta) * 100;

                                const percentProjectionBasedOnProjectionValue = totalProjectionValue.current == 0 ? 0 :((totalSumFullCategory * 12) / totalProjectionValue.current) * 100;
                                const percentAveragePerUnitBasedOnAveragePerUnit = totalAveragePerUnit.current == 0 ? 0 :((totalSumFullCategory / branches.length) / totalAveragePerUnit.current) * 100;
                                
                                return (
                                    <>
                                        <td className="text-end">{formatCurrency(totalVariableExpenses)}</td>
                                        <td className="text-center" data-tippy-content={`${totalVariableExpenses} de ${totalReceitaBrutaBranch}`}>{percent.toFixed(2)}%</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{formatCurrency(totalSumFullCategory)}</td>
                                                <td className="text-center" data-tippy-content={`${totalSumFullCategory} de ${receitaBruta}`}>{totalPercentBasedOnTotalReceitaBruta.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalSumFullCategory * 12)}</td>
                                                <td className="text-center">{percentProjectionBasedOnProjectionValue.toFixed(2)}%</td>
                                                <td className="text-end">{formatCurrency(totalSumFullCategory / branches.length)}</td>
                                                <td className="text-center">{percentAveragePerUnitBasedOnAveragePerUnit.toFixed(2)}%</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        <tr className="total-row">
                            <td>&nbsp;</td>
                            <td className="text-center">% TOTAL</td>
                            {branches.map((branch, index) => {
                                let totalReceitaBruta = data.revenue.total;
                                if (category == 'despesa-variavel') {
                                    totalReceitaBruta = data.revenue.total ?? 0;
                                } else if (category == 'despesa-fixa') {
                                    totalReceitaBruta = data.expenses.total ?? 0;
                                }
                                const totalReceitaBrutaBranch = data.expenses_hierarchy[0].SUBCATEGORIAS[0].ITENS.find(item => item.FILIAL_ID == branch.ID)?.total_approved ?? 0;
                                const totalDeducted = totalsDeductionPerBranch.current?.[branch.ID]?.total ?? 0;
                                const totalReceitaLiquida = totalReceitaBrutaBranch - totalDeducted;
                                const percent = totalReceitaBruta == 0 ? 0 :(totalReceitaLiquida / totalReceitaBruta) * 100;
                                totalFullCategorySumPercent += percent;
                                return (
                                    <>
                                        <td className="text-center" data-tippy-content={`${totalReceitaLiquida} de ${totalReceitaBruta}`}>{percent.toFixed(2)}%</td>
                                        <td>&nbsp;</td>
                                        {index == branches.length - 1 && (
                                            <>
                                                <td>&nbsp;</td>
                                                <td className="text-end">{totalFullCategorySumPercent.toFixed(2)}%</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-center">&nbsp;</td>
                                                <td className="text-center">&nbsp;</td>
                                            </>
                                        )}
                                    </>
                                )
                            })}
                        </tr>
                        {generateDreTableParts('jump-line')}
                        {mountSubcategoriesRows}
                    </>
                )
        //}

        window.reloadIconss();
    }

    const exportDreToExcel = () => {
        // Criar workbook e worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([]);
        
        // Definir as cores baseadas nas classes CSS
        const colorMap = {
            'yellow-row': { fill: { fgColor: { rgb: "FFFF00" } } },
            'blue-row': { fill: { fgColor: { rgb: "0070C0" } } },
            'sublevel': { fill: { fgColor: { rgb: "FFFFFF" } } },
            'total-row': { fill: { fgColor: { rgb: "D9D9D9" } } },
            'despesa-row': { fill: { fgColor: { rgb: "0070C0" } } },
            'despesa-fixa-row': { fill: { fgColor: { rgb: "FF0000" } } },
            'receita-liquida-row': { fill: { fgColor: { rgb: "00B0F0" } } },
            'despesa-variavel-row': { fill: { fgColor: { rgb: "FFC000" } } },
            'margem-contribuicao-row': { fill: { fgColor: { rgb: "92D050" } } },
            'resultado-operacional-row': { fill: { fgColor: { rgb: "92D050" } } },
            'despesa-nao-operacional-row': { fill: { fgColor: { rgb: "953734" } } },
            'despesa-total-row': { fill: { fgColor: { rgb: "7F7F7F" } } },
            'resultado-liquido-row': { fill: { fgColor: { rgb: "00B050" } } },
            'ponto-equilibrio-row': { fill: { fgColor: { rgb: "00B0F0" } } },
            'despesa-por-unidade-row': { fill: { fgColor: { rgb: "7F7F7F" } } }
        };
        
        // Pegar a tabela do DOM
        const table = document.querySelector('.sticky-table');
        const rows = table.querySelectorAll('tr');
        
        let excelData = [];
        let cellStyles = {};
        
        rows.forEach((row, rowIndex) => {
            const cells = row.querySelectorAll('th, td');
            const rowData = [];
            const rowClass = Array.from(row.classList).find(cls => colorMap[cls]);
            
            cells.forEach((cell, colIndex) => {
                const cellValue = cell.textContent.trim();
                rowData.push(cellValue);
                
                // Aplicar estilo se a linha tiver cor
                if (rowClass) {
                    const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                    cellStyles[cellRef] = {
                        ...colorMap[rowClass],
                        font: { bold: cell.tagName === 'TH' }
                    };
                }
            });
            
            excelData.push(rowData);
        });
        
        // Adicionar dados ao worksheet
        XLSX.utils.sheet_add_aoa(worksheet, excelData, { origin: 'A1' });
        
        // Aplicar estilos às células
        worksheet['!cols'] = [];
        worksheet['!rows'] = [];
        
        // Definir larguras das colunas
        for (let i = 0; i < excelData[0].length; i++) {
            worksheet['!cols'][i] = { width: i === 0 ? 5 : i === 1 ? 30 : 15 };
        }
        
        // Definir alturas das linhas
        for (let i = 0; i < excelData.length; i++) {
            worksheet['!rows'][i] = { hpt: 25 };
        }
        
        // Aplicar estilos às células
        Object.keys(cellStyles).forEach(cellRef => {
            if (worksheet[cellRef]) {
                worksheet[cellRef].s = cellStyles[cellRef];
            }
        });
        
        // Adicionar worksheet ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'DRE');
        
        // Gerar nome do arquivo com data
        const now = new Date();
        const fileName = `DRE_${now.getFullYear()}_${String(now.getMonth() + 1).padStart(2, '0')}_${String(now.getDate()).padStart(2, '0')}.xlsx`;
        
        // Exportar arquivo
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <div className="container-fluid p-3">
            <style>
                {`
                    .table-container {
                        height: 800px;
                        width: 100%;
                        overflow: auto;
                        border: 1px solidrgb(73, 80, 87);
                    }

                    .sticky-table {
                        border-collapse: separate;
                        border-spacing: 0;
                    }

                    .sticky-table thead tr:nth-child(1) th,
                    .sticky-table thead tr:nth-child(2) th,
                    .sticky-table thead tr:nth-child(3) th,
                    .sticky-table thead tr:nth-child(4) th,
                    .sticky-table thead tr:nth-child(5) th {
                        position: sticky;
                        background-color: #f8f9fa;
                        z-index: 10;
                        border-bottom: 1px solid #dee2e6;
                    }

                    .sticky-table thead tr:nth-child(1) th { top: 0; }
                    .sticky-table thead tr:nth-child(2) th { top: 38px; }
                    .sticky-table thead tr:nth-child(3) th { top: 76px; }
                    .sticky-table thead tr:nth-child(4) th { top: 114px; }
                    .sticky-table thead tr:nth-child(5) th { top: 152px; }

                    .sticky-table th:nth-child(1),
                    .sticky-table td:nth-child(1) {
                        position: sticky;
                        left: 0;
                        background-color: #f8f9fa;
                        z-index: 5;
                        border-right: 2px solid #dee2e6;
                        min-width: 60px;
                    }

                    .sticky-table th:nth-child(2),
                    .sticky-table td:nth-child(2) {
                        position: sticky;
                        left: 60px;
                        background-color: #f8f9fa;
                        z-index: 5;
                        border-right: 2px solid #dee2e6;
                        min-width: 200px;
                    }

                    .sticky-table thead tr:nth-child(1) th:nth-child(1),
                    .sticky-table thead tr:nth-child(1) th:nth-child(2),
                    .sticky-table thead tr:nth-child(2) th:nth-child(1),
                    .sticky-table thead tr:nth-child(2) th:nth-child(2),
                    .sticky-table thead tr:nth-child(3) th:nth-child(1),
                    .sticky-table thead tr:nth-child(3) th:nth-child(2),
                    .sticky-table thead tr:nth-child(4) th:nth-child(1),
                    .sticky-table thead tr:nth-child(4) th:nth-child(2),
                    .sticky-table thead tr:nth-child(5) th:nth-child(1),
                    .sticky-table thead tr:nth-child(5) th:nth-child(2) {
                        z-index: 15;
                        background-color: #e9ecef;
                    }

                    .sticky-table th,
                    .sticky-table td {
                        min-width: 120px;
                        padding: 8px 12px;
                        text-align: left;
                        border-bottom: 1px solid #dee2e6;
                        white-space: nowrap;
                    }

                    .sticky-table tbody tr:hover td:not(:nth-child(-n+2)) {
                        background-color: #f8f9fa;
                    }

                    .sublevel {
                        background:#FFF !important;
                    }
                    .sublevel th {
                        background:#FFF !important;
                    }
                    .sublevel td {
                        background:#FFF !important;
                    }
                    .sublevel .normal-title {
                        font-weight: 400 !important;
                    }

                    .yellow-row {
                        background:#ffff00;
                        color: #000;
                    }
                    .yellow-row th {
                        background:#ffff00 !important;
                        color: #000 !important;
                    }
                    .yellow-row td {
                        background:#ffff00 !important;
                        color: #000 !important;
                    }

                    .blue-row {
                        background:#0070c0;
                        color: #000;
                    }
                    .blue-row th {
                        background:#0070c0 !important;
                        color: #000 !important;
                    }
                    .blue-row td {
                        background:#0070c0 !important;
                        color: #000 !important;
                    }

                    .despesa-row {
                        background:#0070c0;
                        color: #000;
                    }
                    .despesa-row th {
                        background:#0070c0 !important;
                        color: #000 !important;
                    }
                    .despesa-row td {
                        background:#0070c0 !important;
                        color: #000 !important;
                    }

                    .despesa-fixa-row {
                        background:#ff0000 !important;
                        color: #000;
                    }
                    .despesa-fixa-row th {
                        background:#ff0000 !important;
                        color: #000 !important;
                    }
                    .despesa-fixa-row td {
                        background:#ff0000 !important;
                        color: #000 !important;
                    }

                    .receita-liquida-row {
                        background:#00b0f0 !important;
                        color: #000;
                    }
                    .receita-liquida-row th {
                        background:#00b0f0 !important;
                        color: #000 !important;
                    }
                    .receita-liquida-row td {
                        background:#00b0f0 !important;
                        color: #000 !important;
                    }

                    .despesa-variavel-row {
                        background:#ffc000 !important;
                        color: #000;
                    }
                    .despesa-variavel-row th {
                        background:#ffc000 !important;
                        color: #000 !important;
                    }
                    .despesa-variavel-row td {
                        background:#ffc000 !important;
                        color: #000 !important;
                    }

                    .margem-contribuicao-row {
                        background:#92d050 !important;
                        color: #000;
                    }
                    .margem-contribuicao-row th {
                        background:#92d050 !important;
                        color: #000 !important;
                    }
                    .margem-contribuicao-row td {
                        background:#92d050 !important;
                        color: #000 !important;
                    }

                    .resultado-operacional-row {
                        background:#92d050 !important;
                        color: #000;
                    }
                    .resultado-operacional-row th {
                        background:#92d050 !important;
                        color: #000 !important;
                    }
                    .resultado-operacional-row td {
                        background:#92d050 !important;
                        color: #000 !important;
                    }

                    .despesa-nao-operacional-row {
                        background:#953734 !important;
                        color: #000;
                    }
                    .despesa-nao-operacional-row th {
                        background:#953734 !important;
                        color: #000 !important;
                    }
                    .despesa-nao-operacional-row td {
                        background:#953734 !important;
                        color: #000 !important;
                    }

                    .despesa-total-row {
                        background:#7f7f7f !important;
                        color: #000;
                    }
                    .despesa-total-row th {
                        background:#7f7f7f !important;
                        color: #000 !important;
                    }
                    .despesa-total-row td {
                        background:#7f7f7f !important;
                        color: #000 !important;
                    }

                    .resultado-liquido-row {
                        background:#00b050 !important;
                        color: #000;
                    }
                    .resultado-liquido-row th {
                        background:#00b050 !important;
                        color: #000 !important;
                    }
                    .resultado-liquido-row td {
                        background:#00b050 !important;
                        color: #000 !important;
                    }

                    .ponto-equilibrio-row {
                        background:#00b0f0 !important;
                        color: #000;
                    }
                    .ponto-equilibrio-row th {
                        background:#00b0f0 !important;
                        color: #000 !important;
                    }
                    .ponto-equilibrio-row td {
                        background:#00b0f0 !important;
                        color: #000 !important;
                    }

                    .despesa-por-unidade-row {
                        background:#7f7f7f !important;
                        color: #000;
                    }
                    .despesa-por-unidade-row th {
                        background:#7f7f7f !important;
                        color: #000 !important;
                    }
                    .despesa-por-unidade-row td {
                        background:#7f7f7f !important;
                        color: #000 !important;
                    }

                    .total-row {
                        background:#d9d9d9 !important;
                        color: #000;
                    }
                    .total-row th {
                        background:#d9d9d9 !important;
                        color: #000 !important;
                    }
                    .total-row td {
                        background:#d9d9d9 !important;
                        color: #000 !important;
                    }
                `}
            </style>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="mb-0">DRE</h1>
                <button 
                    className="btn btn-success" 
                    onClick={exportDreToExcel}
                    style={{ marginLeft: '10px' }}
                >
                    <i className="fas fa-file-excel me-2"></i>
                    Exportar Excel
                </button>
            </div>
            <div className="table-container">
                <table className="sticky-table">
                    <thead>
                        <tr className="yellow-row">
                            <th>&nbsp;</th>
                            <th>MARK. SOBRE FATURAMENTO</th>
                            {generateDreTableParts('titulo-tabela')}
                        </tr>
                        <tr className="blue-row">
                            <th>1</th>
                            <th>RECEITA BRUTA</th>
                            {generateDreTableParts('receita-bruta')}
                        </tr>
                        <tr className="sublevel">
                            <th>&nbsp;</th>
                            <th className="normal-title">RECEITA CLIENTE</th>
                            {generateDreTableParts('receita-bruta:receita-cliente')}
                        </tr >
                        <tr className="sublevel">
                            <th>&nbsp;</th>
                            <th className="normal-title">RECEITA JUROS APLICAÇÃO BANCÁRIA</th>
                            {generateDreTableParts('receita-bruta:receita-juros-aplicacao-bancaria')}
                        </tr>
                        <tr className="total-row">
                            <th>&nbsp;</th>
                            <th className="text-center">% TOTAL</th>
                            {generateDreTableParts('receita-bruta:totals-percent')}
                        </tr>
                    </thead>
                    <tbody>
                        {generateDreTableParts('jump-line')}
                        {generateDreTableParts('deducao-de-receita')}
                        {generateDreTableParts('receita-liquida')}
                        {generateDreTableFullcategory('despesa-variavel')}
                        {generateDreTableParts('margem-contribuicao')}
                        {generateDreTableFullcategory('despesa-fixa')}
                        {generateDreTableParts('resultado-operacional')}
                        {generateDreTableFullcategory('despesa-nao-operacional')}
                        {generateDreTableParts('despesa-total')}
                        {generateDreTableParts('resultado-liquido')}
                        {generateDreTableParts('ponto-equilibrio')}
                        {generateDreTableParts('despesa-por-unidade')}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FinancialDRE; 